import React from "react";
import AppRoutes from "../routes";
import Header from "../components/myaniture/layouts/header";
import Footer from "../components/myaniture/layouts/footer";
import HomePage from "../pages/myaniture/home_page";
const MyanitureTemplate = () => {
  return (
    <div>
      <React.Fragment>
        <AppRoutes homePage={HomePage} />
        <Footer />
      </React.Fragment>
    </div>
  );
};

export default MyanitureTemplate;
